import React from "react";
import {
  FileText, FileSpreadsheet, FileArchive, FileType, FileImage,
  FileAudio, FileVideo, FileCode, File as FileIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Mime-type driven document icon.
 * Returns a themed Lucide icon based on the document's mime_type.
 * Used to replace the ugly green-block fallback on Documents when an image
 * fails to load or when the doc is a non-image file.
 */
export function mimeMeta(mime) {
  const m = (mime || "").toLowerCase();
  if (m.startsWith("image/"))                return { Icon: FileImage,       color: "text-purple-500",  bg: "bg-purple-500/12" };
  if (m.startsWith("video/"))                return { Icon: FileVideo,       color: "text-pink-500",    bg: "bg-pink-500/12" };
  if (m.startsWith("audio/"))                return { Icon: FileAudio,       color: "text-sky-500",     bg: "bg-sky-500/12" };
  if (m.includes("pdf"))                     return { Icon: FileText,        color: "text-rose-500",    bg: "bg-rose-500/12" };
  if (m.includes("sheet") || m.includes("excel") || m.includes("csv"))
                                              return { Icon: FileSpreadsheet, color: "text-emerald-500", bg: "bg-emerald-500/12" };
  if (m.includes("zip") || m.includes("tar") || m.includes("rar") || m.includes("compress"))
                                              return { Icon: FileArchive,     color: "text-amber-500",   bg: "bg-amber-500/12" };
  if (m.includes("word") || m.includes("document") || m.includes("opendocument"))
                                              return { Icon: FileType,        color: "text-indigo-500",  bg: "bg-indigo-500/12" };
  if (m.includes("json") || m.includes("xml") || m.includes("javascript") || m.includes("html") || m.includes("code"))
                                              return { Icon: FileCode,        color: "text-slate-500",   bg: "bg-slate-500/12" };
  return { Icon: FileIcon, color: "text-muted-foreground", bg: "bg-muted" };
}

export default function MimeIcon({ mime, className }) {
  const { Icon, color, bg } = mimeMeta(mime);
  return (
    <div className={cn("h-full w-full grid place-items-center", bg, className)}>
      <Icon className={cn("h-6 w-6", color)} strokeWidth={1.8} />
    </div>
  );
}
